import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";
import ShotGunTemplateNew from "pages/secure/facility/settings/teesheets/ShotGunTemplate/ShotGunTemplateNew";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    facilityStore: { ...state.facilityStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShotGunTemplateNew);
